import { ApiComponentType, ApiService } from '@ibe/api';
import React, { JSX } from 'react';
import { ComponentBoxProps } from '../../../Models/ItemRegistry';
import PackageBox from '../../Components/PackageBox/PackageBox';
import PackageBoxServiceInfoLayout from '../../Components/PackageBox/PackageBoxServiceInfoLayout';
import { Slider, withMedia } from '../../Components/UI/Slider/Slider';
import default404Image from '../../Components/UI/Images/Default404Image';

const PackageComponentBox = (props: ComponentBoxProps): JSX.Element => {
  const { component, onModifyComponent, onRemoveComponent } = props;
  const service = component.selectedItems[0] as ApiService;

  const handleShowServices = (): void => {
    if (onModifyComponent) {
      onModifyComponent(component.id);
    }
  };

  return (
    <PackageBox
      header={withMedia(Slider, default404Image, service.media, {
        mobileControls: true
      })}
      onRemoveComponent={(): void =>
        onRemoveComponent && onRemoveComponent(component.id, service.id)
      }
      content={
        <PackageBoxServiceInfoLayout
          headline={service.name}
          startDate={service.start ? service.start : ''}
          endDate={service.end ? service.end : ''}
          onShowServiceOptions={(): void => handleShowServices()}
        />
      }
      isIncluded={component.componentType !== ApiComponentType.OPTIONAL}
    />
  );
};

export default PackageComponentBox;
